module.exports = __webpack_public_path__ + "static/media/avatar_lam.fc1424d0.mp4";